import { SupportChannels } from '@jotta/ui/SupportChannels'
import { PublicLayout } from '../components/Layout/PublicLayout'
import { Trans } from '@lingui/macro'

export function SupportRoute() {
  // TODO check if we should auto-redirect to external support
  return (
    <PublicLayout section="support" className="mx-auto max-w-lg p-16">
      <h1 className="title-lg pb-8 text-center">
        <Trans>Contact support</Trans>
      </h1>
      <SupportChannels />
    </PublicLayout>
  )
}
